import SelectInput from './SelectInput';
import TextInput from './TextInput';
import AreaInput from './AreaInput';
import NumberInput from './NumberInput';
import ToogleInput from './ToogleInput';
import ToogleSwitch from './ToogleSwitch';
import SlideInput from './SlideInput';
import FileInput from './FileInput';


export {SelectInput, TextInput, AreaInput,
    FileInput, ToogleSwitch,
    NumberInput, ToogleInput, SlideInput}



// WEBPACK FOOTER //
// src/component/Forms/index.js